import { render, staticRenderFns } from "./DiscoveryTable.vue?vue&type=template&id=597ff7c8&scoped=true&"
import script from "./DiscoveryTable.vue?vue&type=script&lang=js&"
export * from "./DiscoveryTable.vue?vue&type=script&lang=js&"
import style0 from "./DiscoveryTable.vue?vue&type=style&index=0&id=597ff7c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597ff7c8",
  null
  
)

export default component.exports